import { useId, useState } from "react";
import { Button } from "@/components/Button";
import { EnrollmentSteps } from "@/components/EnrollmentChecklist";

export function SetupDisclosure({
  entityType,
  createdAt,
  lastSeenAt,
}: {
  entityType: "connector" | "gateway";
  createdAt: string;
  lastSeenAt: string | null;
}) {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="overflow-hidden rounded-lg bg-surface">
      <div className="flex items-center justify-between gap-4 px-4 py-3">
        <p className="text-sm text-foreground/70">Setup and install commands</p>
        <Button
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-controls={panelId}
          size="sm"
        >
          {open ? "Hide" : "Show"}
        </Button>
      </div>

      {open && (
        <div id={panelId} className="border-t border-muted/60 p-4">
          <EnrollmentSteps
            entityType={entityType}
            createdAt={createdAt}
            lastSeenAt={lastSeenAt}
          />
        </div>
      )}
    </div>
  );
}
